'use client'
import { jsx } from 'react/jsx-runtime';
import '@dynamic-labs/sdk-api-core';
import '../../../../../../shared/logger.js';
import '@dynamic-labs/iconic';
import '@dynamic-labs/wallet-connector-core';
import '../../../../../../context/ViewContext/ViewContext.js';
import 'react';
import { ReactComponent as SvgCheckCircle } from '../../../../../../shared/assets/check-circle.js';
import '@dynamic-labs/wallet-book';
import '../../../../../../utils/constants/colors.js';
import '../../../../../../utils/constants/values.js';
import '../../../../../../shared/utils/classes/storage/localStorage.js';
import '../../../../../../shared/utils/classes/storage/sessionStorage.js';
import '@dynamic-labs/utils';
import '../../../../../../shared/consts/index.js';
import { classNames } from '../../../../../../utils/functions/classNames/classNames.js';
import { Tooltip } from '../../../../../Tooltip/Tooltip.js';
import { Typography } from '../../../../../Typography/Typography.js';

const VerifiedFieldTooltip = (content) => (jsx(Typography, { variant: 'numbers_medium', color: 'tooltip', children: content }));
const VerifiedUserFieldIcon = ({ className, overwriteTooltipProps, tooltipContent, copykey, }) => (jsx(Tooltip, Object.assign({ content: VerifiedFieldTooltip(tooltipContent) }, overwriteTooltipProps, { copykey: copykey, children: jsx(SvgCheckCircle, { className: classNames('dynamic-verified-icon', className) }) })));

export { VerifiedUserFieldIcon };
